import { useCallback } from "react"
import { PropTypes } from "prop-types"

import useFastField from "../useFastField"
import PasswordField from "."

/**
 * Wrapper for the PasswordField component to let Formik handle the form state
 *
 * @export {function} PasswordFieldWrapper
 * @param {object} props PasswordFieldWrapper props
 * @returns {function} PasswordFieldWrapper
 */
export default function PasswordFieldWrapper({ name, ...rest }) {
  const { field, error, helpers, touched } = useFastField(name)
  const { setTouched, setValue } = helpers
  const onChange = useCallback((key, value) => setValue(value), [setValue])
  const onBlur = useCallback(() => setTouched(true), [setTouched])

  return (
    <PasswordField
      {...field}
      error={error}
      onBlur={onBlur}
      onChange={onChange}
      touched={field.value ? touched : false}
      {...rest}
    />
  )
}

PasswordFieldWrapper.propTypes = {
  name: PropTypes.string.isRequired
}
